<div class="col gap-16">
    <div class="w100 row space-between">
        <div class="icon">
            <rr-icon name="settings"></rr-icon>
        </div>
        <rr-icon name="close" class="close" (click)="close()"></rr-icon>
    </div>
    <h1 i18n>Settings</h1>
    <rr-tab-control [activeStep]="page">
        <rr-tab step="1" label="Basic Info">
            <app-basicinfos
                [companyData]="user.companyData"
                [lang]="user.lang"
                (companyChange)="changeCompanyData($event)"
            ></app-basicinfos>
        </rr-tab>
        <rr-tab step="2" label="Project Knowledge">
            <app-projectknowledge></app-projectknowledge>
        </rr-tab>
        <rr-tab step="3" label="Team Members">
            <app-teammembers></app-teammembers>
        </rr-tab>
    </rr-tab-control>
</div>
<div class="row btnrow justify-end gap-16">
    <rr-btn i18n type="Secondary" (click)="close()">Close</rr-btn>
    <rr-btn i18n type="Primary" (click)="save()">Save</rr-btn>
</div>
